module.exports = __webpack_public_path__ + "img/minus-square.078d95b2.svg";